const initialState = {
  data: [],
  params: null,
  allData: [],
  totalPages: 0,
  filteredData: [],
  totalRecords: 0,
  sortIndex: [],
  kategori: [],
  provinsi: [],
  kota: []
}

const determinePopularity = val => {
  if (val >= 75) return { popValue: val, color: "success" }
  else if (val < 75 && val >= 55) return { popValue: val, color: "primary" }
  else if (val < 55 && val >= 35) return { popValue: val, color: "warning" }
  else if (val < 35 && val >= 0) return { popValue: val, color: "danger" }
  else return { popValue: 0, color: "danger" }
}

const moveIndex = (arr, from, to) => {
  let el = arr[from]
  arr.splice(from, 1)
  arr.splice(to, 0, el)
}

const getIndex = (arr, arr2, arr3, params = {}) => {
  if (arr2.length > 0) {
    let startIndex = arr.findIndex(i => i.id === arr2[0].id) + 1
    let endIndex = arr.findIndex(i => i.id === arr2[arr2.length - 1].id) + 1
    let finalArr = [startIndex, endIndex]
    return (arr3 = finalArr)
  } else {
    let finalArr = [arr.length - parseInt(params.perPage), arr.length]
    return (arr3 = finalArr)
  }
}

const DataListReducer = (state = initialState, action) => {
  switch (action.type) {
    case "VENDOR_AKTIF_GET_DATA":{
      let total_items = state.allData.length
      let limit = action.params._limit
      let totalPages = Math.ceil(total_items/limit)
      return {
        ...state,
        data: action.data,
        totalPages: totalPages === 0 ? action.totalPages : totalPages,
        params: action.params,
        sortIndex: getIndex(
          state.allData,
          action.data,
          state.sortIndex,
          action.params
        )
      }
    }
    case "VENDOR_AKTIF_GET_ALL_DATA":
      return {
        ...state,
        allData: action.data,
        totalRecords: action.data.length,
        sortIndex: getIndex(action.data, state.data, state.sortIndex)
      }
    case "VENDOR_IN_REVIEW_GET_DATA":{
      let total_items = state.allData.length
      let limit = action.params._limit
      let totalPages = Math.ceil(total_items/limit)
      return {
        ...state,
        data: action.data,
        totalPages: totalPages === 0 ? action.totalPages : totalPages,
        params: action.params,
        sortIndex: getIndex(
          state.allData,
          action.data,
          state.sortIndex,
          action.params
        )
      }
    }
    case "VENDOR_IN_REVIEW_GET_ALL_DATA":
      return {
        ...state,
        allData: action.data,
        totalRecords: action.data.length,
        sortIndex: getIndex(action.data, state.data, state.sortIndex)
      }
    case "VENDOR_PROBLEM_GET_DATA":{
      let total_items = state.allData.length
      let limit = action.params._limit
      let totalPages = Math.ceil(total_items/limit)
      return {
        ...state,
        data: action.data,
        totalPages: totalPages === 0 ? action.totalPages : totalPages,
        params: action.params,
        sortIndex: getIndex(
          state.allData,
          action.data,
          state.sortIndex,
          action.params
        )
      }
    }
    case "VENDOR_PROBLEM_GET_ALL_DATA":
      return {
        ...state,
        allData: action.data,
        totalRecords: action.data.length,
        sortIndex: getIndex(action.data, state.data, state.sortIndex)
      }
    case "VENDOR_FILTER_DATA":{
      let value = action.value
      let filteredData = []
      if (value.length) {
        filteredData = state.allData
          .filter(item => {
            let startsWithCondition =
              (item.nama_perusahaan ? item.nama_perusahaan.toLowerCase().startsWith(value.toLowerCase()) : false) ||
              (item.alamat ? item.alamat.toLowerCase().startsWith(value.toLowerCase()) : false) ||
              (item.email ? item.email.toLowerCase().startsWith(value.toLowerCase()) : false) ||
              (item.nomor_telepon ? item.nomor_telepon.toLowerCase().startsWith(value.toLowerCase()) : false) ||
              (item.kota ? item.kota.nama.toLowerCase().startsWith(value.toLowerCase()) : false) ||
              (item.provinsi ? item.provinsi.nama.toLowerCase().startsWith(value.toLowerCase()) : false) ||
              (item.sbu ? item.sbu.sub_bidang.toLowerCase().startsWith(value.toLowerCase()) : false) ||
              (item.vendor_industries.filter(kategori => kategori.nama.toLowerCase().startsWith(value.toLowerCase())).length ? true : false)

            let includesCondition =
              (item.nama_perusahaan ? item.nama_perusahaan.toLowerCase().includes(value.toLowerCase()) : false) ||
              (item.alamat ? item.alamat.toLowerCase().includes(value.toLowerCase()) : false) ||
              (item.email ? item.email.toLowerCase().includes(value.toLowerCase()) : false) ||
              (item.nomor_telepon ? item.nomor_telepon.toLowerCase().includes(value.toLowerCase()) : false) ||
              (item.kota ? item.kota.nama.toLowerCase().includes(value.toLowerCase()) : false) ||
              (item.provinsi ? item.provinsi.nama.toLowerCase().includes(value.toLowerCase()) : false) ||
              (item.sbu ? item.sbu.sub_bidang.toLowerCase().includes(value.toLowerCase()) : false) ||
              (item.vendor_industries.filter(kategori => kategori.nama.toLowerCase().includes(value.toLowerCase())).length ? true : false)

            if (startsWithCondition) {
              return startsWithCondition
            } else if (!startsWithCondition && includesCondition) {
              return includesCondition
            } else return null
          })
          .slice(state.params.page - 1, state.params.perPage)
        return { ...state, filteredData }
      } else {
        filteredData = state.data
        return { ...state, filteredData }
      }
    }
    case "VENDOR_GET_DATA_BY_ID":
      return {
        ...state,
        data: action.data,
      }
    case "FILTER_DATA":
      let value = action.value
      let filteredData = []
      if (value.length) {
        filteredData = state.allData
          .filter(item => {
            let startsWithCondition =
              item.name.toLowerCase().startsWith(value.toLowerCase()) ||
              item.category.toLowerCase().startsWith(value.toLowerCase()) ||
              item.price.toLowerCase().startsWith(value.toLowerCase()) ||
              item.order_status.toLowerCase().startsWith(value.toLowerCase())

            let includesCondition =
              item.name.toLowerCase().includes(value.toLowerCase()) ||
              item.category.toLowerCase().includes(value.toLowerCase()) ||
              item.price.toLowerCase().includes(value.toLowerCase()) ||
              item.order_status.toLowerCase().includes(value.toLowerCase())

            if (startsWithCondition) {
              return startsWithCondition
            } else if (!startsWithCondition && includesCondition) {
              return includesCondition
            } else return null
          })
          .slice(state.params.page - 1, state.params.perPage)
        return { ...state, filteredData }
      } else {
        filteredData = state.data
        return { ...state, filteredData }
      }
    case "VENDOR_AKTIF_UPDATE_DATA":
      // state.data.find(item => {
      //   if (item.id === action.obj.id) {
      //     // let popularity = determinePopularity(action.obj.popularity.popValue)
      //     // return Object.assign(item, { ...action.obj, popularity })
      //   } else {
      //     return item
      //   }
      // })
      return { ...state, data: action.data }
    case "VENDOR_TERVERIFIKASI":
      return { ...state }
    case "VENDOR_PERSYARATAN_BELUM_TERPENUHI":
      return { ...state }
    case "VENDOR_KATEGORI_GET_DATA":{
      let total_items = state.allData.length
      let limit = action.params._limit
      let totalPages = Math.ceil(total_items/limit)
      return {
        ...state,
        data: action.data,
        totalPages: totalPages === 0 ? action.totalPages : totalPages,
        params: action.params,
        sortIndex: getIndex(
          state.allData,
          action.data,
          state.sortIndex,
          action.params
        )
      }
    }
    case "VENDOR_KATEGORI_GET_ALL_DATA":
      return {
        ...state,
        kategori: action.data,
        allData: action.data,
        totalRecords: action.data.length,
        sortIndex: getIndex(action.data, state.data, state.sortIndex)
      }
    case "VENDOR_KATEGORI_FILTER_DATA":{
      let value = action.value
      let filteredData = []
      if (value.length) {
        filteredData = state.allData
          .filter(item => {
            let startsWithCondition =
              item.nama.toLowerCase().startsWith(value.toLowerCase()) ||
              item.keterangan.toLowerCase().startsWith(value.toLowerCase())

            let includesCondition =
              item.nama.toLowerCase().includes(value.toLowerCase()) ||
              item.keterangan.toLowerCase().includes(value.toLowerCase())

            if (startsWithCondition) {
              return startsWithCondition
            } else if (!startsWithCondition && includesCondition) {
              return includesCondition
            } else return null
          })
          .slice(state.params.page - 1, state.params.perPage)
        return { ...state, filteredData }
      } else {
        filteredData = state.data
        return { ...state, filteredData }
      }
    }
    case "VENDOR_KATEGORI_ADD_DATA":{
      let data = [...state.data]
      let allData = [...state.allData]
      data.push(action.obj)
      allData.push(action.obj)

      let total_items = allData.length
      let limit = action.params._limit
      let totalPages = Math.ceil(total_items/limit)
      return {
        ...state,
        allData: allData,
        data: data,
        totalRecords: allData.length,
        totalPages: totalPages,
        sortIndex: getIndex(allData, data, state.sortIndex)
      }
    }
    case "VENDOR_KATEGORI_UPDATE_DATA":{
      let data = [...state.data]
      let index = data.findIndex(obj => obj.id === action.obj.id)
      data[index] = action.obj
      return { ...state, data: data }
    }
    case "VENDOR_KATEGORI_DELETE_DATA":{
      let index = state.data.findIndex(item => item.id === action.obj.id)
      let updatedData = [...state.data]
      updatedData.splice(index, 1)

      let indexAllData = state.allData.findIndex(item => item.id === action.obj.id)
      let updatedAllData = [...state.allData]
      updatedAllData.splice(indexAllData, 1)
      return {
        ...state,
        data: updatedData,
        totalRecords: updatedAllData.length,
        sortIndex: getIndex(
          updatedAllData,
          state.data,
          state.sortIndex,
          state.params
        )
      }
    }
    case "VENDOR_KELAS_GET_DATA":{
      let total_items = state.allData.length
      let limit = action.params._limit
      let totalPages = Math.ceil(total_items/limit)
      return {
        ...state,
        data: action.data,
        totalPages: totalPages === 0 ? action.totalPages : totalPages,
        params: action.params,
        sortIndex: getIndex(
          state.allData,
          action.data,
          state.sortIndex,
          action.params
        )
      }
    }
    case "VENDOR_KELAS_GET_ALL_DATA":
      return {
        ...state,
        kategori: action.data,
        allData: action.data,
        totalRecords: action.data.length,
        sortIndex: getIndex(action.data, state.data, state.sortIndex)
      }
    case "VENDOR_KELAS_FILTER_DATA":{
      let value = action.value
      let filteredData = []
      if (value.length) {
        filteredData = state.allData
          .filter(item => {
            let startsWithCondition =
              item.kbli.toString().toLowerCase().startsWith(value.toLowerCase()) ||
              item.kegiatan.toLowerCase().startsWith(value.toLowerCase())

            let includesCondition =
              item.kbli.toString().toLowerCase().includes(value.toLowerCase()) ||
              item.kegiatan.toLowerCase().includes(value.toLowerCase())

            if (startsWithCondition) {
              return startsWithCondition
            } else if (!startsWithCondition && includesCondition) {
              return includesCondition
            } else return null
          })
          .slice(state.params.page - 1, state.params.perPage)
        return { ...state, filteredData }
      } else {
        filteredData = state.data
        return { ...state, filteredData }
      }
    }
    case "VENDOR_KELAS_ADD_DATA":{
      let data = [...state.data]
      let allData = [...state.allData]
      data.push(action.obj)
      allData.push(action.obj)

      let total_items = allData.length
      let limit = action.params._limit
      let totalPages = Math.ceil(total_items/limit)
      return {
        ...state,
        allData: allData,
        data: data,
        totalRecords: allData.length,
        totalPages: totalPages,
        sortIndex: getIndex(allData, data, state.sortIndex)
      }
    }
    case "VENDOR_KELAS_UPDATE_DATA":{
      let data = [...state.data]
      let index = data.findIndex(obj => obj.id === action.obj.id)
      data[index] = action.obj
      return { ...state, data: data }
    }
    case "VENDOR_KELAS_DELETE_DATA":{
      let index = state.data.findIndex(item => item.id === action.obj.id)
      let updatedData = [...state.data]
      updatedData.splice(index, 1)

      let indexAllData = state.allData.findIndex(item => item.id === action.obj.id)
      let updatedAllData = [...state.allData]
      updatedAllData.splice(indexAllData, 1)
      return {
        ...state,
        data: updatedData,
        totalRecords: updatedAllData.length,
        sortIndex: getIndex(
          updatedAllData,
          state.data,
          state.sortIndex,
          state.params
        )
      }
    }
    case "VENDOR_KELAS_IMPORT_DATA":{
      action.obj.forEach(element => {
        let id = state.data.slice(-1)[0].id + 1
        state.data.push({
          ...element,
          id,
          // popularity: determinePopularity(action.obj.popularity)
        })
        moveIndex(
          state.data,
          state.data.findIndex(item => item.id === id),
          0
        )
      });
      return {
        ...state,
        data: state.data,
        totalRecords: state.allData.length,
        sortIndex: getIndex(state.allData, state.data, state.sortIndex)
      }
    }
    case "VENDOR_SBU_GET_DATA":{
      let total_items = state.allData.length
      let limit = action.params._limit
      let totalPages = Math.ceil(total_items/limit)
      return {
        ...state,
        data: action.data,
        totalPages: totalPages === 0 ? action.totalPages : totalPages,
        params: action.params,
        sortIndex: getIndex(
          state.allData,
          action.data,
          state.sortIndex,
          action.params
        )
      }
    }
    case "VENDOR_SBU_GET_ALL_DATA":
      return {
        ...state,
        kategori: action.data,
        allData: action.data,
        totalRecords: action.data.length,
        sortIndex: getIndex(action.data, state.data, state.sortIndex)
      }
    case "VENDOR_SBU_FILTER_DATA":{
      let value = action.value
      let filteredData = []
      if (value.length) {
        filteredData = state.allData
          .filter(item => {
            let startsWithCondition =
              item.kode.toLowerCase().startsWith(value.toLowerCase()) ||
              item.sub_bidang.toLowerCase().startsWith(value.toLowerCase())

            let includesCondition =
              item.kode.toLowerCase().includes(value.toLowerCase()) ||
              item.sub_bidang.toLowerCase().includes(value.toLowerCase())

            if (startsWithCondition) {
              return startsWithCondition
            } else if (!startsWithCondition && includesCondition) {
              return includesCondition
            } else return null
          })
          .slice(state.params.page - 1, state.params.perPage)
        return { ...state, filteredData }
      } else {
        filteredData = state.data
        return { ...state, filteredData }
      }
    }
    case "VENDOR_SBU_ADD_DATA":{
      let data = [...state.data]
      let allData = [...state.allData]
      data.push(action.obj)
      allData.push(action.obj)

      let total_items = allData.length
      let limit = action.params._limit
      let totalPages = Math.ceil(total_items/limit)
      return {
        ...state,
        allData: allData,
        data: data,
        totalRecords: allData.length,
        totalPages: totalPages,
        sortIndex: getIndex(allData, data, state.sortIndex)
      }
    }
    case "VENDOR_SBU_UPDATE_DATA":{
      let data = [...state.data]
      let index = data.findIndex(obj => obj.id === action.obj.id)
      data[index] = action.obj
      return { ...state, data: data }
    }
    case "VENDOR_SBU_DELETE_DATA":{
      let index = state.data.findIndex(item => item.id === action.obj.id)
      let updatedData = [...state.data]
      updatedData.splice(index, 1)

      let indexAllData = state.allData.findIndex(item => item.id === action.obj.id)
      let updatedAllData = [...state.allData]
      updatedAllData.splice(indexAllData, 1)
      return {
        ...state,
        data: updatedData,
        totalRecords: updatedAllData.length,
        sortIndex: getIndex(
          updatedAllData,
          state.data,
          state.sortIndex,
          state.params
        )
      }
    }
    case "VENDOR_SBU_IMPORT_DATA":{
      action.obj.forEach(element => {
        let id = state.data.slice(-1)[0].id + 1
        state.data.push({
          ...element,
          id,
          // popularity: determinePopularity(action.obj.popularity)
        })
        moveIndex(
          state.data,
          state.data.findIndex(item => item.id === id),
          0
        )
      });
      return {
        ...state,
        data: state.data,
        totalRecords: state.allData.length,
        sortIndex: getIndex(state.allData, state.data, state.sortIndex)
      }
    }
    case "PROVINSI_GET_ALL_DATA":
      return {
        ...state,
        provinsi: action.data
      }
    case "KOTA_GET_ALL_DATA":
      return {
        ...state,
        kota: action.data
      }
    case "VENDOR_GET_DATA_PEMESANAN":{
        let total_items = state.allData.length
        let limit = action.params._limit
        let totalPages = Math.ceil(total_items/limit)
        return {
          ...state,
          data: action.data,
          totalPages: totalPages === 0 ? action.totalPages : totalPages,
          params: action.params,
          sortIndex: getIndex(
            state.allData,
            action.data,
            state.sortIndex,
            action.params
          )
        }
      }
    case "VENDOR_GET_ALL_DATA_PEMESANAN":
      return {
        ...state,
        allData: action.data,
        totalRecords: action.data.length,
        sortIndex: getIndex(action.data, state.data, state.sortIndex)
      }
    case "FILTER_DATA_VENDOR_PEMESANAN":{
      let value = action.value
      let filteredData = []
      if (value.length) {
        filteredData = state.allData
          .filter(item => {
            let startsWithCondition =
              item.nomor.toLowerCase().startsWith(value.toLowerCase()) ||
              item.created_at.toLowerCase().startsWith(value.toLowerCase()) ||
              item.kepada.toLowerCase().startsWith(value.toLowerCase()) ||
              item.status.toLowerCase().startsWith(value.toLowerCase()) ||
              item.tgl_penyerahan.toLowerCase().startsWith(value.toLowerCase())

            let includesCondition =
              item.nomor.toLowerCase().includes(value.toLowerCase()) ||
              item.created_at.toLowerCase().includes(value.toLowerCase()) ||
              item.kepada.toLowerCase().includes(value.toLowerCase()) ||
              item.status.toLowerCase().includes(value.toLowerCase()) ||
              item.tgl_penyerahan.toLowerCase().includes(value.toLowerCase())

            if (startsWithCondition) {
              return startsWithCondition
            } else if (!startsWithCondition && includesCondition) {
              return includesCondition
            } else return null
          })
          .slice(state.params.page - 1, state.params.perPage)
        return { ...state, filteredData }
      } else {
        filteredData = state.data
        return { ...state, filteredData }
      }
    }
    case "FILTER_DATA_VENDOR_PEMESANAN_STATUS":{
      let value = action.value
      let filteredData = []
      if (value) {
        filteredData = state.allData
        .filter(item => {
          let includesCondition =
            item.status.toLowerCase().includes(value.toLowerCase())

          if (includesCondition) {
            return includesCondition
          } else return null
        })
        .slice(state.params.page - 1, state.params.perPage)
        return { ...state, filteredData }
      } else {
        filteredData = state.data
        return { ...state, filteredData }
      }
    }
    case "VENDOR_PEMESANAN_GET_DATA":
      return {
        ...state,
        data: action.data,
      }
    // case "KATALOG_PEMESANAN_UPLOAD_PDF":{
    //   return {
    //     ...state,
    //     data: state.data,
    //   }
    // }
    default:
      return state
  }
}

export default DataListReducer
